import type { RealmInfo } from '../index';
export const testRealmURL = `http://test-realm/test/`;
export const testHostModeRealmURL = 'http://test-realm/user/test/';

export const testRealmInfo: RealmInfo = {
  name: 'Unnamed Workspace',
  backgroundURL: null,
  iconURL: null,
  showAsCatalog: null,
  interactHome: null,
  hostHome: null,
  visibility: 'public',
  realmUserId: '@realm_server:localhost',
  publishable: null,
  lastPublishedAt: null,
};
